import { streetViewsByAccommodationCategoryId } from 'Views/booking/BookingEngine.query';
import { createOptimisticAction } from 'Store/utils/createAction';
import { FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID } from './constants';
export type StreetViewsByAccommodationCategoryIdQueryParam = {
  productId: string;
  accommodationCategoryIds: ReadonlyArray<string> | string;
};
export function fetchStreetViewsByAccommodationCategoryId({
  productId,
  accommodationCategoryIds,
  appContext,
}: StreetViewsByAccommodationCategoryIdQueryParam & {
  appContext: AppContext;
}) {
  return (dispatch: ReduxDispatch) => {
    return dispatch(
      createOptimisticAction(
        FETCH_STREET_VIEWS_BY_ACCOMMODATION_CATEGORY_ID,
        {},
        {
          optimist: true,
          promise: streetViewsByAccommodationCategoryId(
            {
              productId,
              accommodationCategoryIds,
            },
            appContext,
          ),
        },
      ),
    );
  };
}
